module.exports = __webpack_public_path__ + "78f2fb20b5f35cd352ede1f0e12bac05.svg";